import React, { useState } from "react";
import { Switch } from "@mui/material";
import API from "src/axios/instances/API";
import styled from "styled-components";
import useGlobalStore from "src/store/useGlobalStore";

const SwitchWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 6px 12px;
  width: 100%;
  border-radius: 4px;
  background: #eeeeee;
  border: ${(props) =>
    props?.$isLoading ? "1px solid lightgray" : "1px solid transparent"};

  transition: 200ms ease-in;
`;

const SwitchText = styled.p`
  font-weight: 500;
  color: ${(props) =>
    props?.$isLoading
      ? "lightgray"
      : props?.$checked
        ? "#337ab7"
        : "slategrey"};
  font-size: 14px;

  transition: color 200ms ease-in;
`;

const BypassReportPermissions = ({ byPassValue, setError }) => {
  const [isLoading, setIsLoading] = useState(false);
  const refetchConfigBackground = useGlobalStore(
    (state) => state.refetchConfigBackground,
  );

  const handleByPass = async (e) => {
    try {
      setIsLoading(true);
      await API.put("/dashboard/account/superuser-bypass-report-permissions/", {
        bypass_report_permissions: e.target.checked,
      });
      await refetchConfigBackground();
      setIsLoading(false);
    } catch (error) {
      setError("Error toggling bypass permissions");
      setIsLoading(false);
    }
  };

  return (
    <SwitchWrapper $isLoading={isLoading}>
      <SwitchText $checked={byPassValue} $isLoading={isLoading}>
        {byPassValue
          ? "Bypass Permissions Enabled"
          : "Bypass Permissions Not Enabled"}
      </SwitchText>
      <Switch
        size="small"
        checked={byPassValue}
        onChange={handleByPass}
        disabled={isLoading}
      />
    </SwitchWrapper>
  );
};

export default BypassReportPermissions;
